import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyB_eJnUMI1Te48h8RZ7PglkprIjRHVqeFg",
    authDomain: "twitter-clone-d86ec.firebaseapp.com",
    databaseURL: "https://twitter-clone-d86ec.firebaseio.com",
    projectId: "twitter-clone-d86ec",
    storageBucket: "twitter-clone-d86ec.appspot.com",
    messagingSenderId: "1023442881597",
    appId: "1:1023442881597:web:6cffdac2ecf44f5cad6e54",
    measurementId: "G-3SVX1TG53E"
  };


  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db = firebaseApp.firestore();

  export default db;